{
  "pt": {
    "choice": {
      "actions": {
        "delete_choice": "Remover opção",
        "delete_choice_list": "Remover lista de opções"
      },
      "labels": {
        "not_selected": "Não selecionado",
        "selected": "Selecionado"
      },
      "messages": {
        "delete_choice": "Tem a certeza de que pretende remover a opção {title}?",
        "delete_choice_list": "Tem a certeza de que pretende remover a lista de opções {title}?"
      },
      "toasts": {
        "create": "Opção criada com sucesso",
        "delete": "Opção eliminada com êxito",
        "update": "Opção atualizada com sucesso"
      }
    }
  }
}
